// Porta leve para `src/app` e `src/routes` (JS inicial): manifesto, schema de busca, catálogo e o
// carregador da tela. Outro módulo usa a `public.ts` (A06).
export { CREDIT_NOTE_DELETED_PATH, creditNoteDeletedScreen } from './credit-note-deleted.screen';
export { creditNoteDeletedSearch } from './credit-note-deleted.search';
export { loadCreditNoteDeletedMessages } from './credit-note-deleted.catalog';

/** A tela da rota (`CreditNoteDeletedRouteScreen`), por `lazyScreen`. */
export const loadCreditNoteDeletedScreens = () => import('./credit-note-deleted.page');

/** O guia da tela para o Luy (U46), sob demanda. */
export const loadCreditNoteDeletedGuides = () => import('./credit-note-deleted.guide');
